/**
 * return true when window is defined
 */
export function isBrowser() {
  return typeof window !== 'undefined';
}